import { Component, Input, OnDestroy, output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { addIcons } from 'ionicons';
import * as allIcons from 'ionicons/icons';
import { ConfigObject } from './config-item.model';

@Component({
  selector: 'app-config-item',
  templateUrl: './config-item.component.html',
  styleUrl: './config-item.component.scss',
  standalone: false,
})
export class ConfigItemComponent implements OnDestroy {
  @Input({ required: true }) form!: FormGroup;
  @Input({ required: true }) inputData!: ConfigObject;
  @Input() disable = false;
  toggleExpand = output<boolean>();

  isExpanded = false;

  constructor() {
    addIcons(allIcons);
  }

  ngOnDestroy(): void {
    this.toggleExpand.emit(false);
  }

  updateValue($event: boolean) {
    if ($event === false) {
      this.isExpanded = false;
      this.toggleExpand.emit(false);
    }
  }

  clickExpand() {
    this.isExpanded = !this.isExpanded;
    this.toggleExpand.emit(this.isExpanded);
  }

  get getControl() {
    return this.form.get(this.inputData?.control) as FormControl;
  }
}
